import { motion } from 'framer-motion';
import { Building, Users, Globe } from 'lucide-react';
import { ReactNode } from 'react';

interface AudienceCardProps {
  icon: ReactNode;
  title: string;
  detail: string;
}

const AudienceCard = ({ icon, title, detail }: AudienceCardProps) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
    className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow text-center"
  >
    <div className="w-16 h-16 rounded-lg bg-primary/10 flex items-center justify-center text-primary mx-auto mb-6">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
    <p className="text-gray-600">{detail}</p>
  </motion.div>
);

const TargetAudience = () => {
  const audiences: AudienceCardProps[] = [
    {
      icon: <Building className="h-6 w-6" />,
      title: 'PME et ETI',
      detail: '30 à 1 000 collaborateurs'
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: 'Directions concernées',
      detail: 'DG, DSI, DRH, Marketing'
    },
    {
      icon: <Globe className="h-6 w-6" />,
      title: 'Tout secteur',
      detail: 'Industrie, pharma, services'
    }
  ];

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="heading-lg text-center mb-16">Pour qui ?</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {audiences.map((audience, idx) => (
            <AudienceCard key={idx} {...audience} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
